<template>
  <v-sheet class="customer-details" :color="color" v-bind="$attrs">
    <h3 v-if="showTitle" class="customer-details__title title">
      <slot name="title" :item="customer">
        {{ $t('ORDERS.CUSTOMER_DETAILS') }}:
      </slot>
    </h3>

    <p class="customer-details__item d-flex align-center mb-0">
      <strong class="customer-details__item-name">
        {{ $t('ORDERS.CUSTOMER') }}:
      </strong>
      <span>{{ customer.name || '' }}</span>
      <v-spacer></v-spacer>
      <v-btn class="float-right" small icon :to="to">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </p>
    <p class="customer-details__item caption">
      <span class="customer-details__item-name">
        {{ $t('ITEM.CATEGORY') }}:
      </span>
      <span>{{ customer.category || '' }}</span>
    </p>
    <p class="customer-details__item">
      <strong class="customer-details__item-name">
        {{ $t('ORDERS.PHONE_1') }}:
      </strong>
      <span>{{ customer.phone_1 || '' }}</span>
    </p>
    <p class="customer-details__item">
      <strong class="customer-details__item-name">
        {{ $t('ORDERS.PHONE_2') }}:
      </strong>
      <span>{{ customer.phone_2 || '' }}</span>
    </p>
    <p class="customer-details__item">
      <strong class="customer-details__item-name">
        {{ $t('ORDERS.EMAIL') }}:
      </strong>
      <span>{{ customer.email || '' }}</span>
    </p>
  </v-sheet>
</template>

<script>
export default {
  name: 'CustomerDetails',

  props: {
    customer: {
      type: Object,
      default: () => ({})
    },
    color: {
      type: String,
      default: 'grey lighten-4'
    },
    showTitle: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    to() {
      return {
        name: 'companies.show',
        params: { id: this.customer.id }
      };
    }
  }
};
</script>

<style lang="scss">
.customer-details {
  & &__title,
  & &__item {
    display: block;
    margin-bottom: 1rem;
  }

  & &__item {
    font-size: 1rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  & &__item-name {
    margin-right: 0.4rem;
  }
}
</style>
